module.exports = __webpack_public_path__ + "img/mobile.09cdde64.svg";